/**
 * Formation types (Plan de Estudios → Tipos): Diplomatura, Máster, Curso… The school's own
 * data, loaded from the server. Ids are stable (Formation.type, StudyPlan.category); names,
 * plural, icon, courses and behaviour flags are edited in the app.
 */
const FormationTypeService = {
    types: [],
    // Icons offered in the type editor (same list the server accepts).
    ICONS: Object.freeze(['fa-layer-group', 'fa-graduation-cap', 'fa-book', 'fa-tools', 'fa-bolt', 'fa-film', 'fa-camera',
        'fa-video', 'fa-chalkboard-teacher', 'fa-certificate', 'fa-star', 'fa-users', 'fa-palette', 'fa-music', 'fa-laptop', 'fa-pen']),

    async load() {
        const response = await fetch('/api/formation-types', {headers: {'X-SICAF-CSRF': AuthManager.getCsrfToken()}, cache: 'no-store'});
        const result = await response.json().catch(() => null);
        if (!response.ok || !Array.isArray(result?.types)) throw new Error(result?.error || 'No se pudieron cargar los tipos de formación.');
        this.types = result.types;
        return this.types;
    },

    sorted(list) { return [...list].sort((a, b) => a.order - b.order || String(a.name).localeCompare(String(b.name), 'es')); },
    getTypes({includeInactive = true} = {}) { return this.sorted(this.types.filter(type => includeInactive || type.active)); },
    getType(id) { return this.types.find(type => type.id === id) || null; },
    // Display names; an unknown id (data not migrated yet) shows as it is.
    name(id) { return this.getType(id)?.name || id || ''; },
    plural(id) { return this.getType(id)?.pluralName || id || ''; },
    icon(id) { return this.getType(id)?.icon || 'fa-layer-group'; },
    color(id) { return this.getType(id)?.color || '#64748b'; },
    // First active type: the default tab/filter when nothing is chosen yet.
    firstId() { return this.getTypes({includeInactive: false})[0]?.id || null; },
    years(id) { const years = this.getType(id)?.years; return Array.isArray(years) ? years : []; },
    ranksPreferences(id) { return !!this.getType(id)?.ranksPreferences; },
    warehouseAccess(id) { return !!this.getType(id)?.warehouseAccess; },

    async request(method, id, data) {
        const response = await fetch('/api/formation-types' + (id ? '/' + encodeURIComponent(id) : ''), {
            method, headers: {'Content-Type': 'application/json', 'X-SICAF-CSRF': AuthManager.getCsrfToken()},
            ...(data ? {body: JSON.stringify(data)} : {})
        });
        const result = await response.json().catch(() => null);
        if (!response.ok || !result?.success) throw new Error(result?.error || 'No se pudo guardar el tipo.');
        await this.load();
        return result.type || result;
    },
    create(data) { return this.request('POST', null, data); },
    update(id, data) { return this.request('PUT', id, data); },
    remove(id) { return this.request('DELETE', id); }
};

window.FormationTypeService = FormationTypeService;
